import AppTable from './AppTable.vue';
import AppTableRow from './AppTableRow.vue';
import AppTableCell from './AppTableCell.vue';
import AppTableHead from './AppTableHead.vue';

export type * from './AppTable.types';
export type * from './AppTableRow.types';
export type * from './AppTableCell.types';
export type * from './AppTableHead.types';

export default {
  Table: AppTable,
  Row: AppTableRow,
  Cell: AppTableCell,
  Head: AppTableHead,
};
